import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * Тема «Транспортный тёплый»: янтарь/оранж как акцент, графитовый сайдбар
 * (стили сайдбара — в index.css), тёплый фон, скруглённые карточки.
 */
const brand: MantineColorsTuple = [
  '#fff7ed',
  '#ffedd5',
  '#fed7aa',
  '#fdba74',
  '#fb923c',
  '#f97316',
  '#ea580c', // primaryShade
  '#c2410c',
  '#9a3412',
  '#7c2d12',
];

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 6,
  defaultRadius: 'md',
  colors: { brand },
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
  headings: { fontWeight: '600' },
  components: {
    Card: {
      defaultProps: { radius: 'md' },
    },
  },
});
